import { Icon } from "#components";

export default defineComponent({
  name: "TextLoader",
  props: {
    loading: { type: Boolean, default: false },
    text: { type: String },
  },
  render() {
    if (this.loading) {
      return h(Icon, { name: "svg-spinners:bars-rotate-fade" });
    }

    return this.text;
  },
});
